import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 4px 0;
`

const SLBrokerName = () => (
  <Wrapper>
    <svg width="311px" height="20px" viewBox="0 0 311 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="1.0-Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Broker-Portal---Dashboard---Loading" transform="translate(-565.000000, -64.000000)" fill="#F1F1F4">
          <rect id="broker-name" x="565" y="64" width="311" height="20"/>
        </g>
      </g>
    </svg>
  </Wrapper>
)

export default SLBrokerName
